import { useMutation } from "@apollo/react-hooks";

import { ChangeLessonInput } from "@hubcapp/types";

import editLessonMutation from "../graph-ql/editLessonDetails.graphql";

const useMutationEditLesson = () =>
  useMutation<ChangeLessonInput>(editLessonMutation);

export default useMutationEditLesson;
